import { c as _c } from "react/compiler-runtime";
import useActivityBookingCalculatedPrice from '@/contexts/activityBookingContext/hooks/useActivityBookingCalculatedPrice';
import useActivityBookingFilters from '@/contexts/activityBookingContext/hooks/useActivityBookingFilters';
import useActivityBookingHandlers from '@/contexts/activityBookingContext/hooks/useActivityBookingHandlers';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import usePageFormErrors from '@/contexts/pageContext/hooks/usePageFormErrors';
import { FFormIdEnum } from '@/types/form';
import { Error } from '@winelidays/wld-tsx-2/elements';
import BookingSticky from '../../components/BookingSticky';
import useTunnelExperience from '../../context/hooks/useTunnelExperience';
import AddToCartButton from '../components/AddToCartButton';
const ActivityBookingSticky = () => {
    const $ = _c(21);
    const translate = useTranslate();
    const { experience } = useTunnelExperience();
    const { persons: t0, language: t1, date: t2, time: t3 } = useActivityBookingFilters();
    const { adults, children } = t0;
    const { language } = t1;
    const { startDate } = t2;
    const { eventTime } = t3;
    const { showFormErrors } = usePageFormErrors(FFormIdEnum.BOOKING);
    const { handleBook } = useActivityBookingHandlers();
    const { calculatedPrice } = useActivityBookingCalculatedPrice();
    let t4;
    if ($[0] !== translate) {
        t4 = translate("validation_page.globale_form_errors_message");
        $[0] = translate;
        $[1] = t4;
    }
    else {
        t4 = $[1];
    }
    const globalFormErrorMessage = t4;
    const t5 = experience?.identifier ?? -1;
    const t6 = `${startDate} ${eventTime?.time}:00`;
    const t7 = eventTime?.event?.identifier ?? "undefined";
    const t8 = language;
    let t9;
    if ($[2] !== adults || $[3] !== children) {
        t9 = {
            adults,
            children
        };
        $[2] = adults;
        $[3] = children;
        $[4] = t9;
    }
    else {
        t9 = $[4];
    }
    let t10;
    if ($[5] !== t5 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t10 = {
            bookableId: t5,
            dateTime: t6,
            event: t7,
            lang: t8,
            remainingStock: t9
        };
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t10;
    }
    else {
        t10 = $[10];
    }
    const reservationInProgress = t10;
    let t11;
    if ($[11] !== globalFormErrorMessage || $[12] !== showFormErrors) {
        t11 = showFormErrors ? <Error className="px-6 tunnel-padding-x-reduced-lg">{globalFormErrorMessage}</Error> : null;
        $[11] = globalFormErrorMessage;
        $[12] = showFormErrors;
        $[13] = t11;
    }
    else {
        t11 = $[13];
    }
    let t12;
    if ($[14] !== calculatedPrice || $[15] !== handleBook || $[16] !== reservationInProgress) {
        t12 = <AddToCartButton formId={FFormIdEnum.BOOKING} onClick={handleBook} calculatedPrice={calculatedPrice} reservationInProgress={reservationInProgress}/>;
        $[14] = calculatedPrice;
        $[15] = handleBook;
        $[16] = reservationInProgress;
        $[17] = t12;
    }
    else {
        t12 = $[17];
    }
    let t13;
    if ($[18] !== t11 || $[19] !== t12) {
        t13 = <BookingSticky addToCartButton={<>{t11}{t12}</>}/>;
        $[18] = t11;
        $[19] = t12;
        $[20] = t13;
    }
    else {
        t13 = $[20];
    }
    return t13;
};
export default ActivityBookingSticky;
